var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_91_91)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0951 6.66672H5.90461C5.20329 6.66672 4.63477 7.23525 4.63477 7.93656V18.0953C4.63477 18.7966 5.20329 19.3652 5.90461 19.3652H18.0951C18.7964 19.3652 19.3649 18.7966 19.3649 18.0953V7.93656C19.3649 7.23525 18.7964 6.66672 18.0951 6.66672Z",
    stroke: "#F4F4F9",
    strokeWidth: 1.66667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.61523 10.4763H19.3845",
    stroke: "#F4F4F9",
    strokeWidth: 1.66667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3076 4.7619V7.93651",
    stroke: "#F4F4F9",
    strokeWidth: 1.66667,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.69238 4.7619V7.93651",
    stroke: "#F4F4F9",
    strokeWidth: 1.66667,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_91_91"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/Date.6ee7682441ce5c87049a2e4d3fb84722.svg";
export { ForwardRef as ReactComponent };